export default "__VITE_PUBLIC_ASSET__6a22ec3b__"